module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAOBAMAAADDIxFwAAAAG1BMVEUAAAD////////////////////////////////rTT7CAAAACHRSTlMAiIuEj4EBdsm/Nu8AAABUSURBVAjXY4CAUAYkwNoRgMSLcGlFcJhb0jwM4DwLNwaWZoQUkIBLWigACaZmqFQTmNIQAFMSCmCKqRFEMgKloJJQKbgkI1gBRIsATDNUTyGSA8UBqV4LdQF+OLkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/foot2.png
// module id = cCb6
// module chunks = 48